(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ami-conversation"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {

    // Point this at your deployed worker.
    const CHAT_ENDPOINT = "https://ami-conversation-layer.samueldontoh.workers.dev";

    const status = document.getElementById("ami-local-status");
    const form = document.getElementById("ami-local-form");
    const input = document.getElementById("ami-local-input");
    const sendButton = document.getElementById("ami-local-send");
    const chat = document.getElementById("ami-local-chat");

    let isGenerating = false;
    let handedOff = false;
    let conversation = [];

    function setStatus(message) {
      if (status) status.textContent = message || "";
    }

    function addMessage(role, text) {
      if (!chat) return null;

      const wrapper = document.createElement("div");
      wrapper.className =
        role === "user" ? "ami-message ami-message--user" : "ami-message ami-message--ami";

      const label = document.createElement("div");
      label.className = "ami-message__label";
      label.textContent = role === "user" ? "You" : "Ami";

      const bubble = document.createElement("div");
      bubble.className = "ami-message__bubble";
      bubble.textContent = text || "";

      wrapper.appendChild(label);
      wrapper.appendChild(bubble);
      chat.appendChild(wrapper);
      chat.scrollTop = chat.scrollHeight;

      return bubble;
    }

    function setComposerEnabled(enabled) {
      if (input) input.disabled = !enabled;
      if (sendButton) sendButton.disabled = !enabled;
    }

    function onHandoff(handoffData) {
      // This is the ring-fence boundary: hand the structured summary to
      // your existing deterministic Ami engine (menu build / cart / payment).
      // Replace this with whatever your current Ami entry point expects —
      // e.g. window.Ami.startOrderFlow(handoffData), a redirect, or a
      // custom event your existing code already listens for.
      console.log("[Ami] Handing off to ordering system:", handoffData);

      addMessage("ami", "Great — let's get this set up for you.");
      setStatus("Handing over to your order…");
      handedOff = true;
      setComposerEnabled(false);

      // Example: window.dispatchEvent(new CustomEvent("ami:handoff", { detail: handoffData }));
    }

    async function sendToAmi(message) {
      const res = await fetch(CHAT_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ messages: conversation.concat([{ role: "user", content: message }]) }),
      });

      if (!res.ok) {
        const errText = await res.text().catch(function () { return ""; });
        throw new Error("Request failed (" + res.status + ") " + errText);
      }

      return res.json();
    }

    if (form) {
      form.addEventListener("submit", async function (event) {
        event.preventDefault();

        const message = input ? input.value.trim() : "";
        if (!message || isGenerating || handedOff) return;

        isGenerating = true;
        input.value = "";
        setComposerEnabled(false);
        if (sendButton) sendButton.textContent = "Thinking…";

        addMessage("user", message);
        conversation.push({ role: "user", content: message });

        const assistantBubble = addMessage("ami", "…");
        setStatus("Ami is thinking…");

        try {
          const data = await sendToAmi(message);

          if (data.reply) {
            assistantBubble.textContent = data.reply;
            conversation.push({ role: "assistant", content: data.reply });
          } else if (assistantBubble) {
            assistantBubble.remove();
          }

          setStatus("");

          if (data.handoff) {
            onHandoff(data.handoff);
          }
        } catch (error) {
          console.error("[Ami] request failed:", error);
          if (assistantBubble) {
            assistantBubble.textContent = "I lost my train of thought there. Try that again.";
          }
          setStatus("Something went wrong — please try again.");
        } finally {
          isGenerating = false;
          if (sendButton) sendButton.textContent = "Send";
          if (!handedOff) setComposerEnabled(true);
          if (input) input.focus();
        }
      });
    }

  });

  } catch(e) { console.error(e); }
})();
})();
